var appSettings = require("./appSettings.json");

export const API_URL = appSettings.api_url;

